<template>
  <div class="content-wrap">
    <div class="content">
      <h1 class="title">{{ errorMessage }}</h1>
      <button @click="goToBrokers" class="button">Start New Report</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {
    goToBrokers() {
      this.$router.push({ name: "Broker" });
    },
  }
};
</script>

<style scoped>
  .content-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .content {
    text-align: center;
    font-size: 1.4em;
  }

  .title {
    margin-top: 0;
  }

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    min-width: 175px;
    min-height: 44px;
    border-radius: 8px;
    border: 2px solid transparent;
    background: linear-gradient(to bottom,#3c6399 0%,#0f2e50 100%);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16);
    cursor: pointer;
    color: white;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 0.85em;
    margin: 0 auto;
  }

  .button:hover {
    border: 2px solid #3c6399;
    background: white;
    color: #3c6399
  }

</style>
